export default __webpack_public_path__ + "static/media/bus.899b6579.png";